<template>
  <div v-once class="d-flex fd-column">
    <span class="h6 x-pulse PLACEHOLDER" />
    <span class="text-lg x-pulse PLACEHOLDER" />
    <span class="text-lg x-pulse PLACEHOLDER" />
  </div>
</template>

<script>
export default {
  name: 'job-list-item-placeholder',
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .PLACEHOLDER {
    @include rect(175px, 16px);
    margin: $unit/2 0;

    &:first-child {
      @include rect(150px, 19px);
    }

    &:nth-child(2) {
      width: 125px;
    }
  }
</style>
